import * as React from "react";
import { Translation } from "i18n/config";
import { PricingCardsTranslations } from "./typing";

export const PricingCardsTexts: Translation<PricingCardsTranslations> = {
	es: {
		challengeSingular: "Reto",
		challengePlural: "Retos",
		selectBusinessProfile:
			"Seleccione el perfil jurídico al cual quieres asignar este producto. Recuerda también que no todos los perfiles jurídicos, que existen dentro de Vinglet, están habilitados para este producto.",
		selectAmountOfChallenges: "Seleccione la cantidad de Reto/s.",
		selectAmountTalents: "Seleccione la cantidad de ofertas de Talentos.",
		commonPack: "Normal",
		availableForProfiles: "Disponible para perfiles de:",
		unlimitedElearningsPerMothPack: "Elearnings ilimitados por mes",
		fourSlotTalentPerPack: "4 slots para ofertas de Talento por mes",
		adviser: "Asesores",
		startUps: "Start Ups",
		companies: "Empresas",
		accelerators: "Aceleradoras",
		incubators: "Incubadoras",
		businessAngels: "Business Angels",
		institutions: "Instituciones",
		universities: "Universidades",
		chooseProduct: "Elegir Producto",
		availableForProfilesWithAgreement: (
			<>
				{" "}
				Disponible para los siguientes perfiles <b> con convenio firmado</b>:{" "}
			</>
		),
		textForSignAgreementWithUs: (
			<>
				Si aún no has firmado convenio con nosotros y te interesaría,
				<a
					href={"/help/how-to-sign-agreement"}
					target={"_blank"}
					rel="noreferrer"
				>
					{" "}
					puedes clicar aqui para saber como realizarlo.{" "}
				</a>
			</>
		),
		vingletFriends: "Amigos de Vinglet",
		free: "Gratis",
	},
	en: {
		challengeSingular: "Challenge",
		challengePlural: "Challenges",
		selectBusinessProfile:
			"Select the business profile which will have this product. Remember that not every business profile inside Vinglet are able to have this product.",
		selectAmountOfChallenges: "Select the quantity of Challenge/s.",
		selectAmountTalents: "Select the quantity of Talents' offers.",
		commonPack: "Common",
		availableForProfiles: "Available for these profiles:",
		unlimitedElearningsPerMothPack: "Unlimited Elearnings per month",
		fourSlotTalentPerPack: "Four slots for Talent offers per month",
		adviser: "Advisers",
		startUps: "Start Ups",
		companies: "Companies",
		accelerators: "Accelerators",
		incubators: "Incubators",
		businessAngels: "Business Angels",
		institutions: "Institutions",
		universities: "Universities",
		chooseProduct: "Choose Product",
		availableForProfilesWithAgreement: (
			<>
				{" "}
				Available for these profiles <b> with a signed agreement </b>:{" "}
			</>
		),
		textForSignAgreementWithUs: (
			<>
				If you haven&apos;t signed the agreement with us and you&apos;d like it,
				<a
					href={"/help/how-to-sign-agreement"}
					target={"_blank"}
					rel="noreferrer"
				>
					{" "}
					you can click here to do it.{" "}
				</a>
			</>
		),
		vingletFriends: "Vinglet's Friends",
		free: "Free",
	},
	ca: {
		challengeSingular: "Reto",
		challengePlural: "Retos",
		selectBusinessProfile:
			"Seleccione el perfil jurídico al cual quieres asignar este producto. Recuerda también que no todos los perfiles jurídicos, que existen dentro de Vinglet, están habilitados para este producto.",
		selectAmountOfChallenges: "Seleccione la cantidad de Reto/s.",
		selectAmountTalents: "Seleccione la cantidad de ofertas de Talentos.",
		commonPack: "Normal",
		availableForProfiles: "Disponible para perfiles de:",
		unlimitedElearningsPerMothPack: "Elearnings ilimitados por mes",
		fourSlotTalentPerPack: "4 slots para ofertas de Talento por mes",
		adviser: "Asesores",
		startUps: "Start Ups",
		companies: "Empresas",
		accelerators: "Aceleradoras",
		incubators: "Incubadoras",
		businessAngels: "Business Angels",
		institutions: "Instituciones",
		universities: "Universidades",
		chooseProduct: "Elegir Producto",
		availableForProfilesWithAgreement: (
			<>
				{" "}
				Disponible para los siguientes perfiles <b> con convenio firmado</b>:{" "}
			</>
		),
		textForSignAgreementWithUs: (
			<>
				Si aun no has firmado convenio con nosotros y te interesaria,
				<a
					href={"/help/how-to-sign-agreement"}
					target={"_blank"}
					rel="noreferrer"
				>
					{" "}
					puedes clicar aqui para saber como realizarlo.{" "}
				</a>
			</>
		),
		vingletFriends: "Amigos de Vinglet",
		free: "Gratis",
	},
	pt: {
		challengeSingular: "Desafio",
		challengePlural: "Desafios",
		selectBusinessProfile:
			"Selecione o perfil jurídico ao qual deseja atribuir este produto. Lembre-se também de que nem todos os perfis legais que existem no Vinglet estão habilitados para este produto.",
		selectAmountOfChallenges: "Selecione a quantidade de Desafio/s.",
		selectAmountTalents: "Selecione o número de ofertas de Talentos.",
		commonPack: "Normal",
		availableForProfiles: "Disponível para perfis:",
		unlimitedElearningsPerMothPack: "Elearnings ilimitados por mês",
		fourSlotTalentPerPack: "4 slots para ofertas de talentos por mês",
		adviser: "Conselheiros",
		startUps: "Start Ups",
		companies: "Empresas",
		accelerators: "Aceleradores",
		incubators: "Incubadoras",
		businessAngels: "Business Angels",
		institutions: "Instituições",
		universities: "Universidades",
		chooseProduct: "Escolha o produto",
		availableForProfilesWithAgreement: (
			<>
				{" "}
				Disponível para os seguintes perfis <b> com acordo assinado </b>:{" "}
			</>
		),
		textForSignAgreementWithUs: (
			<>
				Se você ainda não assinou um contrato conosco e está interessado,
				<a
					href={"/help/how-to-sign-agreement"}
					target={"_blank"}
					rel="noreferrer"
				>
					{" "}
					você pode clicar aqui para saber como fazê-lo.{" "}
				</a>
			</>
		),
		vingletFriends: "Amigos de Vinglet",
		free: "Gratuito",
	},
};
